import { useResultContext } from "../FormContext";

/**
 * Custom hook for result state management
 *
 * Provides a clean interface for accessing and updating result data
 * Compatible with existing Apollo-based implementations
 *
 * @returns Object containing result data and update functions
 */
export const useResult = () => {
  const { resultData, updateResultData } = useResultContext();

  return {
    resultData,
    updateResultData,
  };
};

/**
 * Apollo-compatible reactive result hook
 *
 * Provides backward compatibility with existing Apollo reactive variable patterns
 * Can be used as a drop-in replacement for Apollo useReactiveVar(result)
 *
 * @returns Function that can get/set result data, mimicking Apollo reactive variables
 */
export const useResultReactive = () => {
  const { resultData, updateResultData } = useResultContext();

  /**
   * Result reactive function
   *
   * When called without arguments, returns current result data
   * When called with data, updates the result data
   *
   * @param newData - Optional new result data to set
   * @returns Current result data
   */
  const result = (newData?: any) => {
    if (newData) {
      updateResultData(newData);
    }
    return resultData;
  };

  return result;
};
